import { Dialog } from '@/components/Dialog';
import { useCatalogOverviewStore } from '@/state/catalog-store';

export const useShowBonusTrackDialog = () => {
  const messageKey = `showBonusTrackDialog`;
  const { catalogOverviewStore } = useCatalogOverviewStore();
  const isNewUser = Object.values(catalogOverviewStore).every((catalogNum) => catalogNum === 0);

  const showDialog = () => {
    const messageShown = localStorage.getItem(messageKey);
    if (!messageShown && !isNewUser) {
      setTimeout(() => {
        Dialog.info({
          closeClassName: 'hidden',
          overlayClassName: 'bg-jen-background-primary',
          canNotCloseOnMask: true,
          dialogContentClassName: 'w-[340px]  outline-none rounded-xl bg-jen-background-primary',
          contentJSX: ({ onClose }) => {
            return (
              <div className="p-[16px] flex flex-col h-full gap-4">
                <div className="leading-6 text-jen-content-primary text-[24px] tracking-[-0.48px]">Here's Your Bonus Jeneration</div>
                <div className="leading-5 text-jen-content-secondary text-jen-size-heading-04">
                  Every track you create includes one bonus jeneration.
                </div>
                <div
                  className="mt-4 h-12 rounded-lg text-jen-content-primary-contrast text-[16px] bg-jen-orange flex justify-center items-center cursor-pointer hover:opacity-90"
                  onClick={() => onClose()}
                >
                  OK
                </div>
              </div>
            );
          },
        });
        localStorage.setItem(messageKey, 'true');
      }, 1800);
    }
  };

  return { showDialog };
};
